import { z } from "zod";

const baseAutoIntegrationListItem = z.object({
	id: z.uuid(),
	externalId: z.string(),
	externalName: z.string(),
	externalMisc: z.string().nullable(),
	integrationData: z.any().default({}),
});

export const autoIntegrationListItemSchema = z.discriminatedUnion("state", [
	baseAutoIntegrationListItem.extend({
		state: z.literal("both"),
		internalId: z.string(),
		internalName: z.string(),
	}),
	baseAutoIntegrationListItem.extend({
		state: z.literal("internal"),
		internalId: z.string(),
		internalName: z.string(),
	}),
	baseAutoIntegrationListItem.extend({
		state: z.literal("external"),
	}),
]);

export const autoIntegrationListSchema = z.array(autoIntegrationListItemSchema);
export const autoIntegrationSchema = z.object({
	list: autoIntegrationListSchema,
	selection: z.array(z.uuid()),
});

export type AutoIntegrationListItemSchema = z.infer<typeof autoIntegrationListItemSchema>;
export type AutoIntegrationListSchema = z.infer<typeof autoIntegrationListSchema>;
export type AutoIntegrationSchema = z.infer<typeof autoIntegrationSchema>;
